(function() {
  // Avoid redefining
  if (window.__b2bBadgeInitIncluded) {
    window.initializeB2BBadges && window.initializeB2BBadges();
    return;
  }
  window.__b2bBadgeInitIncluded = true;

  window.initializeB2BBadges = function() {
    const processedAttr = 'data-b2b-processed';

    document.querySelectorAll('b2b-discount-badge[data-product-handle], b2b-discount-badge[data-product-id]').forEach(badge => {
      try {
        if (badge.getAttribute(processedAttr)) return;

        // Use Liquid-rendered values directly — no Storefront API needed
        // data-liquid-price-cents       = B2B catalog price (e.g. 11800 = 118€)
        // data-liquid-compareat-price-cents = catalog compare_at = UVP (e.g. 16990 = 169,90€)
        const b2bPriceCents      = Number(badge.getAttribute('data-liquid-price-cents') || 0);
        const compareatPriceCents = Number(badge.getAttribute('data-liquid-compareat-price-cents') || 0);
        const percentEl = badge.querySelector('.handlerpreis-badge-percent');

        if (compareatPriceCents > b2bPriceCents && b2bPriceCents > 0) {
          const percent = Math.round((1 - b2bPriceCents / compareatPriceCents) * 100);
          if (percent > 0) {
            if (percentEl) percentEl.textContent = ' ' + percent + '%';
            badge.style.display = 'block';
          }
        }

        badge.setAttribute(processedAttr, 'true');
      } catch (e) {
        console.debug && console.debug('b2b: unexpected error processing badge', e);
      }
    });
  };

  // Bind to theme lifecycle events
  document.addEventListener('DOMContentLoaded', window.initializeB2BBadges);
  document.addEventListener('shopify:section:load', window.initializeB2BBadges);
  document.addEventListener('theme:section:load', window.initializeB2BBadges);
  document.addEventListener('variant:change', window.initializeB2BBadges);

  // MutationObserver to pick up dynamic content
  const observer = new MutationObserver(function(mutations) {
    let added = false;
    mutations.forEach(m => {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.querySelector && node.querySelector('b2b-discount-badge'))) {
            added = true;
          }
        });
      }
    });
    if (added) window.initializeB2BBadges();
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });

  // Run once in case already available
  window.initializeB2BBadges();
})();